/* eslint-disable */
import { ORDERS_ALL_ADDRESSES, ORDERS_ALL_ADDRESSES_COMPLETE, ORDERS_ALL_ADDRESSES_ERROR, ORDERS_ALL_ADDRESSES_SUCCESS } from '../Orders.types';

/**
 * Fetch all known orders addresses
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersAllAddresses = () => ({ orderService, fromPromise, getState }) => {
  const state = getState();
  const promise = orderService.allAddresses(state);
  return fromPromise(promise, {}, [ORDERS_ALL_ADDRESSES, ORDERS_ALL_ADDRESSES_COMPLETE, ORDERS_ALL_ADDRESSES_ERROR, ORDERS_ALL_ADDRESSES_SUCCESS]);
};

export default ordersAllAddresses;
